import { z } from "zod";

/**
 * Zod schema for the SSO callback response.
 * Mirrors the login response schema — the callback API returns the same shape.
 * 
 * API Endpoint: GET /v4/sso/callback?data=...&signature=...
 */
export const SsoCallbackResponseSchema = z.object({
    data: z.object({
        id: z.string(),
        name: z.string(),
        email: z.string().email(),
        email_verified_at: z.string().nullable(),
        created_at: z.string(),
        updated_at: z.string(),
        company: z.any().nullable(),
        channex_user_api_key: z.string().optional(),
        username: z.string().optional(),
        phone: z.string(),
        permissions: z.array(z.string()),
        role: z.array(z.string()),
        active_property: z.string(),
        active_property_id: z.string(),
        is_full_sync: z.boolean(),
        properties: z.record(z.string()),
    }),
    token: z.string(),
    expired: z.string(),
});

export type SsoCallbackResponse = z.infer<typeof SsoCallbackResponseSchema>;
